module.exports = "<create-edit-popup options=\"options\"></create-edit-popup>"